




































































































































































































































































































































import {
  faComment,
  faComments,
  faEllipsisV,
  faReply,
  faShareAlt,
  faThumbsDown,
  faThumbsUp
} from '@fortawesome/free-solid-svg-icons'
import { mapGetters, mapState, mapActions } from 'vuex'
import QnaCommentForm from './QnaAnswerForm.vue'
import { UserType } from '~/models/user/types'
import { QnaQuestion, QnaMetadataMapper } from '~/models/qna/types'
import QnaActions from './QnaActions.vue'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { timeDistanceFromNow } from '~/utils/date'
import { USER_NS } from '~/store/modules/shared/user/state'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import CShareModal from '~/components/shared/configurable/social/CShareModal.vue'
import CShareButtons from '~/components/shared/configurable/social/CShareButtons.vue'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import CContextMenu from '~/components/shared/configurable/CContextMenu.vue'
import { resolveCategory } from '~/utils/category'
import { ReactionEnum } from '~/models/classified-list/types'
import { QNA_NS } from '~/store/modules/shared/qna/state'
import CSeeMoreOverlay from '~/components/shared/configurable/CSeeMoreOverlay.vue'
import { categoriesIconsMappings } from '~/constants/category/icon'
import { VipUsers } from '~/constants/vip-users'
import CExternalLinkMediatorModal from '~/components/shared/configurable/modal/CExternalLinkMediatorModal.vue'
import { Trigger } from '~/models/app/trigger'
import { Position } from '~/models/app/position'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import CAnonGuardModal from '~/components/shared/configurable/user/CAnonGuardModal.vue'

export default defineComponent({
  components: {
    CAnonGuardModal,
    CExternalLinkMediatorModal,
    QnaCommentForm,
    QnaActions,
    CConfirmationModal,
    CShareModal,
    CShareButtons,
    CAvatar,
    CContextMenu,
    CSeeMoreOverlay,
    CBadge
  },
  props: {
    question: { type: Object as PropType<QnaQuestion>, required: true },
    shortDescription: { type: Boolean, default: true },
    linkedTitle: { type: Boolean, default: true },
    headerTagH1: { type: Boolean, default: false },
    displayOnFullQuestion: { type: Boolean, default: false }
  },
  data() {
    return {
      isCommentFormVisible: false,
      isLoading: false,
      answerText: null,
      isConfirmationDialogVisible: false,
      shareModalVisible: false,
      externalLinkMediatorUrl: '',
      showExternalLinkMediatorModal: false,
      isAnonGuardModalVisible: false
    }
  },
  computed: {
    UserType: () => UserType,
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin',
      isAnon: 'isAnon',
      userId: 'userId'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile',
      isPc: 'isPc'
    }),
    ...mapState(USER_NS, {
      permissions: state => state.permissions,
      currentUserId: state => state.id
    }),
    reactionEnum(): ReactionEnum {
      return ReactionEnum
    },
    nextUrl(): string {
      if (process.client) {
        return window.location.href
      }
      return ''
    },
    likes(): number {
      return this.question.reactions.like || 0
    },
    disLikes(): number {
      return this.question.reactions.dislike || 0
    },
    tags() {
      const makesAndModelLink = []
      const categoryId = this.question.questionCategory.id
      if (this.question?.questionMake) {
        makesAndModelLink.push({
          name: this.question.questionMake.name,
          link: this.generateLink({
            category: categoryId,
            make: this.question.questionMake.id
          })
        })
      }
      if (this.question.makemodel?.name) {
        makesAndModelLink.push({
          name: this.question.makemodel.name,
          link: this.generateLink({
            category: categoryId,
            make: this.question.questionMake.id,
            model: this.question.makemodel.id
          })
        })
      }
      const metaTagsLinks = this.question.questionMetadata.map(qm => {
        if (
          qm.key &&
          QnaMetadataMapper[qm.key.toUpperCase()] ===
            QnaMetadataMapper.MAKEMODEL_YEAR
        ) {
          return {
            name: qm.value,
            link: this.generateLink({
              to_year: qm.value,
              from_year: qm.value
            })
          }
        }
        return {
          name: qm.humanName,
          link: this.generateLink({
            category: categoryId,
            [QnaMetadataMapper[qm.key.toUpperCase()]]: qm.value
          })
        }
      })

      return makesAndModelLink.concat(metaTagsLinks)
    },
    shareUrl(): string {
      if (process.client) {
        return (
          window &&
          `${window.location.protocol}//${window.location.hostname}${this.question.seoUrl}`
        )
      }
      return ''
    },
    categoryLink(): string {
      if (this.question?.questionCategory) {
        return this.generateLink({
          category: this.question.questionCategory.id
        })
      }
      return null
    },
    icons() {
      return {
        addAnswer: faReply,
        reply: faComment,
        answer: faComments,
        share: faShareAlt,
        ellipsis: faEllipsisV,
        like: faThumbsUp,
        dLike: faThumbsDown
      }
    },
    myReaction(): string {
      const { myReactions } = this.question
      return myReactions.length ? myReactions[0] : null
    },
    isQuestionBelongsToUser(): boolean {
      return this.userId === this.question.user.id
    },
    pTagsCountInQuestion(): number {
      const { questionText } = this.question
      if (questionText) {
        const charsLength = questionText.length
        const charsLengthWithoutPTags = questionText.replace(/<p>/g, '').length
        return (charsLength - charsLengthWithoutPTags) / 3
      }
      return 0
    },
    isSeeMoreVisible(): boolean {
      const maxChars = 290
      return (
        (this.pTagsCountInQuestion > 2 ||
          this.question?.questionText?.length > maxChars) &&
        this.shortDescription
      )
    },
    isVip(): Boolean {
      return Object.values(VipUsers).includes(this.question.user.id)
    },
    trigger() {
      return Trigger
    },
    position() {
      return Position
    },
    questionAdded() {
      return timeDistanceFromNow(this.question.added)
    }
  },
  methods: {
    ...mapActions(QNA_NS, [
      'deleteQuestion',
      'createComment',
      'createQuestionReaction'
    ]),

    getIcon(categoryIds) {
      return resolveCategory(categoriesIconsMappings, categoryIds)
    },

    handleTextClick(e: MouseEvent) {
      const { hostname } = window.location
      const target = e.target as HTMLAnchorElement
      if (target?.hostname && target.hostname !== hostname) {
        e.preventDefault()
        e.stopPropagation()
        this.externalLinkMediatorUrl = target.href
        this.showExternalLinkMediatorModal = true
      }
    },

    handleReport() {
      this.shareModalVisible = false
    },
    generateLink(query: {}) {
      return this.$router.resolve({
        name: '__qna_view',
        query
      }).href
    },

    handleDelete() {
      this.isConfirmationDialogVisible = true
      this.shareModalVisible = false
    },
    handleEdit(question) {
      this.shareModalVisible = false
      this.$emit('edit', question)
    },
    handleReaction({
      questionId,
      reaction
    }: {
      questionId: string
      reaction: ReactionEnum
    }) {
      if (this.isAnon) {
        this.isAnonGuardModalVisible = true
        return
      }
      this.isLoading = true
      this.createQuestionReaction({ questionId, reaction }).finally(
        () => (this.isLoading = false)
      )
    },

    handleReplySubmit(answer: string) {
      this.isLoading = true
      this.createComment({
        questionId: this.question.id,
        answer,
        isFirstComment: !this.displayOnFullQuestion
      })
        .then(() => (this.isCommentFormVisible = false))
        .finally(() => (this.isLoading = false))
    },
    handleDeleteQuestion() {
      this.shareModalVisible = false
      this.isLoading = true
      this.deleteQuestion({
        question: this.question,
        isAdmin: this.userIsAdmin,
        userId: this.currentUserId
      }).finally(() => {
        this.isLoading = false
      })
    },
    handleClickAnswer() {
      if (this.isAnon) {
        this.isAnonGuardModalVisible = true
      } else {
        this.isCommentFormVisible = !this.isCommentFormVisible
      }
    }
  }
})
